import { render, staticRenderFns } from "./infoRow.vue?vue&type=template&id=228f5406&scoped=true"
import script from "./infoRow.vue?vue&type=script&setup=true&lang=js"
export * from "./infoRow.vue?vue&type=script&setup=true&lang=js"
import style0 from "./infoRow.vue?vue&type=style&index=0&id=228f5406&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228f5406",
  null
  
)

export default component.exports